interface ICalendarIcon {
    width?: number;
    height?: number;
    fill?: string
}

export const CalendarIcon = ({ height = 18, width = 17, fill = "#000" }: ICalendarIcon) => {
    return <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        fill={fill}
        viewBox="0 0 17 18"
    >
        <path
            fill={fill}
            d="M14.733 1.452h-.566V.58c0-.32-.255-.581-.567-.581a.575.575 0 00-.567.58v.872H3.967V.58C3.967.26 3.712 0 3.4 0a.575.575 0 00-.567.58v.872h-.566C1.017 1.452 0 2.494 0 3.774v11.903C0 16.957 1.017 18 2.267 18h12.466C15.983 18 17 16.958 17 15.677V3.774c0-1.28-1.017-2.322-2.267-2.322zM2.267 2.612h12.466c.627 0 1.134.52 1.134 1.162v1.742H1.133V3.774c0-.642.507-1.161 1.134-1.161zM14.733 16.84H2.267c-.627 0-1.134-.52-1.134-1.162v-9h14.734v9c0 .642-.507 1.162-1.134 1.162z"
        ></path>
    </svg>
}